import list from './articleMarket'
export default list
